import * as React from "react";
import "./tab.component.css";
import { useEffect, useState } from "react";
import { MessageResponse } from "../../model/MessageResponse";
import {
  IconHistory,
  IconSearch,
  IconDownload,
  IconCalendar,
  Icon12Hours,
  IconCheck,
  IconX,
  IconChartBar,
} from "@tabler/icons-react";
import {
  MRT_ColumnFiltersState,
  MRT_SortingState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_ColumnDef,
  useMantineReactTable,
  MantineReactTable,
} from "mantine-react-table";
import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Input,
  List,
  Menu,
  rem,
  ScrollArea,
  Select,
  ThemeIcon,
  Tooltip,
  Text,
  Title,
} from "@mantine/core";
import { DateInput, DatePickerInput } from "@mantine/dates";
import { SelectListItem } from "../../model/SelectListItem";
import { getUsersSelect } from "../../const/getSelectApi";
import { _localization } from "../../config/location";
import { modals } from "@mantine/modals";
import Repository from "../../_base/helper/HttpHelper";
import { ProcessApprove } from "../../model/ProcessApprove";
import PopupProcess from "./PopupProcess";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import {
  ApprovalHistoryModelQuery,
  WorkHistoryModelQuery,
} from "../../model/HistoryFolderModel";
import { useForm } from "@mantine/form";
import { ListApprovalHistorySearchModel } from "../../model/BaseSearchModel";
import {
  getColorByType,
  pageTable,
  repositorySign,
  signTypes,
  styleTable,
} from "../../_base/_const/_constVar";
import { formatDateTransfer } from "../../_base/extension/FormatDate";
import WorkHistoryView from "./WorkHistoryView";
import HistoryProfile from "../Func/CreateProfile/HistoryProfile/HistoryProfile";
import { useNavigate } from "react-router-dom";
import BreadcrumbLayout1 from "../../_base/component/_layout/_breadcrumb";
import CompanyStatisticsModal from "../../component/CompanyStatisticsModal";
const TaskTable = () => {
  //#region  table

  //data and fetching state
  const [data, setData] = useState<ApprovalHistoryModelQuery[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [selectIds, setSelectIds] = useState<number[] | string[]>([]);
  // const [openedMenu, setOpenedMenu] = useState(true);
  const [dataUpdated, setDataUpdated] = useState(false);

  const [dataListUser, setDataListUser] = useState<SelectListItem[]>([]);
  const _span = { base: 6, sm: 4, md: 3, lg: 3, xl: 2 };

  const [height, setHeight] = useState(0);
  const headerRef = React.useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const [companyStatsOpened, setCompanyStatsOpened] = useState(false);
  const search: ListApprovalHistorySearchModel = {
    skip: 0,
    take: 0,
  };
  const form = useForm({
    mode: "uncontrolled",
    initialValues: search,
  });
  const dataStatus = [
    { value: "PHE_DUYET", label: "Phê duyệt" },
    { value: "CHUA_XU_LY", label: "Chưa xử lý" },
    { value: "TU_CHOI", label: "Từ chối" },
  ];

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    let _softing = "";
    if (sorting && sorting.length > 0) {
      let _q = sorting[0];
      if (_q) _softing = _q.id;
    }
    try {
      const queryParams: ListApprovalHistorySearchModel = {
        skip: pagination.pageIndex * pagination.pageSize,
        take: pagination.pageSize,
        keySearch: form.getValues().keySearch,
        sort: _softing,
        isOrder: sorting.length > 0 ? sorting[0].desc : true,
        DocTypeId: form.getValues().DocTypeId,
        Status: form.getValues().Status,
        EmpId: form.getValues().EmpId,
        FromDate: form.getValues().FromDate,
        ToDate: form.getValues().ToDate,
      };

      const baseUrl = "/api/v1/SubmissionHistory/list-approval-history";
      const queryString = Object.entries(queryParams)
        .reduce((acc, [key, value]) => {
          if (value !== undefined && value !== null && value !== "") {
            const stringValue =
              value instanceof Date ? value.toISOString() : value.toString();
            return `${acc}&${key}=${encodeURIComponent(stringValue)}`;
          }
          return acc;
        }, "")
        .replace(/^&/, "");
      const url = `${baseUrl}${queryString ? `?${queryString}` : ""}`;
      const response = await repositorySign.get<
        MessageResponse<ApprovalHistoryModelQuery[]>
      >(url);

      if (response && response.success) {
        const dataList = response?.data;
        setData(dataList);
        setRowCount(response.totalCount);
        setDataUpdated(true);
        // await dataOrderTypeSelect();
        table.resetRowSelection();
      }
    } catch (error) {
      setIsError(true);
      console.error(error);
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  async function getUser() {
    const data = await getUsersSelect();
    if (data && data.length > 0) setDataListUser(data);
  }

  const openModelHistory = (ids: number | null) =>
    modals.openConfirmModal({
      title: <Title order={4}>Lịch sử phê duyệt</Title>,
      size: "100%",
      children: <HistoryProfile ids={ids} />,
      labels: { confirm: "Confirm", cancel: "Cancel" },
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => console.log("Confirmed"),
    });
  const handleEditTable = (ids: string | number) => {
    navigate("/method/folders-edit", {
      state: { id: ids },
    });
  };

  useEffect(() => {
    fetchData();
  }, [pagination.pageIndex, pagination.pageSize, sorting]);

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
  }, [rowSelection]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (180 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const openHistoryFlow = async (id: number) => {
    if (id > 0) {
      setIsLoading(true);
      setIsRefetching(true);
      let url = `/api/v1/SubmissionHistory/detail-approval-history?setupSignStepId=${id}`;
      const callapi = await repositorySign.get<
        MessageResponse<WorkHistoryModelQuery[]>
      >(url);
      console.log("dataaaaa", callapi);

      if (callapi?.success && callapi.data) {
        modals.openConfirmModal({
          title: "",
          children: (
            <>
              <div className="e-card-header">
                <div className="e-card-header-caption">
                  <div className="e-card-header-title e-card-3-black">
                    Quá trình duyệt
                  </div>
                </div>
              </div>
              <Grid>
                {/* <Grid.Col span={8}>
                  <PopupProcess data={callapi.data}></PopupProcess>
                </Grid.Col> */}
                <Grid.Col span={4}>
                  <Text fw={600} mb={"sm"}>
                    Chú thích
                  </Text>
                  <List
                    spacing="xs"
                    size="sm"
                    center
                    icon={
                      <IconCheck style={{ width: rem(18), height: rem(18) }} />
                    }
                  >
                    <List.Item
                      icon={
                        <ThemeIcon color="blue" size={26} radius="xl">
                          <IconCheck
                            style={{ width: rem(25), height: rem(25) }}
                          />
                        </ThemeIcon>
                      }
                    >
                      Đã duyệt thành công
                    </List.Item>
                    <List.Item
                      icon={
                        <ThemeIcon color="red" size={26} radius="xl">
                          <IconX style={{ width: rem(20), height: rem(20) }} />
                        </ThemeIcon>
                      }
                    >
                      Từ chối phê duyệt
                    </List.Item>
                    <List.Item
                      icon={
                        <ThemeIcon color="gray" size={26} radius="xl">
                          <Icon12Hours
                            style={{ width: rem(20), height: rem(20) }}
                          />
                        </ThemeIcon>
                      }
                    >
                      Chưa được xử lý
                    </List.Item>
                  </List>
                </Grid.Col>
              </Grid>
            </>
          ),
          labels: { confirm: "Đóng", cancel: "Cancel" },
          onCancel: () => console.log("Cancel"),
          onConfirm: () => console.log("Confirmed"),
          cancelProps: { display: "none" },
          size: "70%",
          scrollAreaComponent: ScrollArea.Autosize,
        });
      } else NotificationExtension.Info("Không có lịch sử phê duyệt !");
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  const handleOpenWorkflow = async (id: number) => {
    modals.openConfirmModal({
      title: "Lịch sử công việc",
      children: (
        <ScrollArea style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
          <WorkHistoryView id={id} onClose={() => modals.closeAll()} />
        </ScrollArea>
      ),
      styles: {
        body: {
          overflow: "auto",
        },
      },
      labels: { confirm: "Đóng", cancel: "Cancel" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => console.log("Confirmed"),
      cancelProps: { display: "none" },
      size: "70%",
      scrollAreaComponent: ScrollArea.Autosize,
    });
  };

  function progessTemplate(props: ApprovalHistoryModelQuery) {
    return (
      <>
        <Tooltip label="Xem thông tin">
          <ActionIcon
            onClick={() => {
              const _id = props.stepId;
              if (_id < 1)
                NotificationExtension.Fails("Mã hồ sơ không hợp lệ !");
              else navigate(`/method/sign-page/${_id}?view=1`);
            }}
            variant="light"
            aria-label="Settings"
            color="blue"
          >
            <IconSearch size={14} stroke={1.5} />
          </ActionIcon>
        </Tooltip>
        <Tooltip label="Lịch sử công việc">
          <ActionIcon
            // onClick={async (e) => {
            //   await openHistoryFlow(props.stepupStepSignId);
            // }}
            // onClick={async (e) => {
            //   await handleOpenWorkflow(props.stepupStepSignId);
            // }}
            onClick={async (e) => {
              await openModelHistory(props.docId);
            }}
            variant="light"
            aria-label="Settings"
            color="cyan"
          >
            <IconHistory size={14} stroke={1.5} />
          </ActionIcon>
        </Tooltip>
      </>
    );
  }

  function getTextColorStatus(text: string) {
    switch (text.trim()) {
      case "PHE_DUYET":
        return {
          color: "green",
          text: "Phê duyệt",
        };
      case "CHUA_XU_LY":
        return {
          color: "teal",
          text: "Chưa xử lý",
        };
      case "TU_CHOI":
        return {
          color: "red",
          text: "Từ chối",
        };
      default:
        return {
          color: "orange",
          text: "Đang tạo",
        };
    }
  }

  const columns = React.useMemo<MRT_ColumnDef<ApprovalHistoryModelQuery>[]>(
    () => [
      {
        accessorKey: "stepupStepSignId",
        header: "Id",
      },
      {
        accessorKey: "docId",
        header: "DocId",
      },
      {
        accessorKey: "stepId",
        header: "stepId",
      },
      {
        accessorKey: "docCode",
        header: "Mã hồ sơ",
      },
      {
        accessorKey: "type",
        header: "Loại ký",
        Cell: ({ renderedCellValue }: any) => {
          const type = signTypes.find((x) => x.value === renderedCellValue);
          const color = type ? getColorByType(type.value) : "gray";

          return <Badge color={color}>{type?.label || "Unknown"}</Badge>;
        },
      },
      {
        accessorKey: "status",
        header: "Hành động",
        Cell: ({ renderedCellValue, row }) => (
          <>
            <Badge
              variant="light"
              color={
                getTextColorStatus(renderedCellValue?.toString() ?? "").color
              }
            >
              {getTextColorStatus(renderedCellValue?.toString() ?? "").text}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "stepName",
        header: "Tên công việc",
      },
      {
        accessorKey: "docName",
        header: "Tên hồ sơ",
      },
      {
        accessorKey: "processingDate",
        header: "Ngày xử lý",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatDateTransfer(renderedCellValue)}</>
        ),
      },

      {
        accessorKey: "receiptDate",
        header: "Ngày nhận",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableSorting: false,
        size: 50,
        Cell: ({ renderedCellValue, row }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
            }}
          >
            {progessTemplate(row.original)}
          </Box>
        ),
      },
    ],
    []
  );

  console.log(data, "data table");
  const table = useMantineReactTable({
    columns,
    data,
    positionToolbarAlertBanner: "bottom",
    renderTopToolbarCustomActions: () => <></>,
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row?.stepupStepSignId?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        right: ["action"],
      },
      columnVisibility: {
        stepupStepSignId: false,
        docId: false,
        stepId: false,
      },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    mantineTableBodyRowProps: ({ row }) => ({
      onDoubleClick: () => {
        const _id = row.original.stepId;
        if (_id < 1) {
          NotificationExtension.Fails("Mã hồ sơ không hợp lệ !");
        } else {
          navigate(`/method/sign-page/${_id}?view=1`);
        }
      },
      style: {
        cursor: 'pointer'
      }
    }),
    enableStickyHeader: true,
    enableExpanding: false,
    onRowSelectionChange: setRowSelection,
    // manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    rowCount,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    mantineTableBodyCellProps: () => ({
      style: styleTable,
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: pageTable,
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });

  return (
    <>
      <div
        style={{ border: "1px solid #dee2e6", padding: "10px" }}
        ref={headerRef}
      >
        <Flex justify="space-between" align="center">
          <BreadcrumbLayout1 />
          <Flex
            gap="md"
            justify={{ sm: "flex-start", lg: "flex-end" }}
            align="center"
            direction="row"
            wrap="wrap"
          >
            <Button
              leftSection={<IconChartBar size={14} />}
              color="blue"
              variant="outline"
              onClick={() => setCompanyStatsOpened(true)}
            >
              Thống kê toàn công ty
            </Button>
            <Button
              leftSection={<IconDownload size={14} />}
              color="violet"
              variant="outline"
              onClick={() => {
                NotificationExtension.Success("Chức năng đang phát triển !");
              }}
            >
              Export Excel
            </Button>
          </Flex>
        </Flex>

        <form>
          <Grid>
            <Grid.Col span={_span}>
              {" "}
              <Input.Wrapper label="Từ khóa">
                <Input
                  leftSection={<IconSearch color="#15aabf" />}
                  placeholder="Nhập từ khóa"
                  key={form.key(`keySearch`)}
                  {...form.getInputProps("keySearch")}
                />{" "}
              </Input.Wrapper>
            </Grid.Col>
            <Grid.Col span={_span}>
              <Select
                label="Trạng thái"
                placeholder="Chọn..."
                clearable
                searchable
                limit={50}
                comboboxProps={{
                  transitionProps: {
                    transition: "pop",
                    duration: 200,
                  },
                }}
                data={dataStatus.map((item) => {
                  return {
                    label: item.label ?? "",
                    value: String(item.value ?? ""),
                  };
                })}
                nothingFoundMessage="Dữ liệu không có !"
                key={form.key(`Status`)}
                {...form.getInputProps("Status")}
              />
            </Grid.Col>

            <Grid.Col span={_span}>
              <Select
                label="Người thao tác"
                placeholder="Chọn..."
                clearable
                searchable
                limit={50}
                comboboxProps={{
                  transitionProps: {
                    transition: "pop",
                    duration: 200,
                  },
                }}
                data={dataListUser.map((item) => {
                  return {
                    label: item.text ?? "",
                    value: String(item.value ?? ""),
                  };
                })}
                onClick={async () => {
                  if (!dataListUser || dataListUser.length < 1) {
                    await getUser();
                  }
                  return;
                }}
                nothingFoundMessage="Dữ liệu không có !"
                key={form.key(`CreateBy`)}
                {...form.getInputProps("CreateBy")}
              />
            </Grid.Col>

            <Grid.Col span={_span}>
              <DateInput
                leftSection={<IconCalendar size={14} />}
                valueFormat="DD/MM/YYYY"
                placeholder="Chọn..."
                label="Từ ngày"
                key={form.key(`FromDate`)}
                {...form.getInputProps("FromDate")}
                clearable
              />
            </Grid.Col>
            <Grid.Col span={_span}>
              <DateInput
                placeholder="Chọn..."
                leftSection={<IconCalendar size={14} />}
                valueFormat="DD/MM/YYYY"
                label="Đến ngày"
                key={form.key(`ToDate`)}
                {...form.getInputProps("ToDate")}
                clearable
              />
            </Grid.Col>
            <Grid.Col span={_span}>
              {" "}
              <Button
                mt={"25px"}
                leftSection={<IconSearch size={14} />}
                color="blue"
                variant="outline"
                onClick={async (e) => {
                  console.log(form.getValues());
                  await fetchData();
                }}
              >
                Tìm kiếm
              </Button>
            </Grid.Col>
          </Grid>
        </form>
      </div>
      <div style={{ 
        padding: '8px 12px', 
        backgroundColor: '#f8f9fa', 
        border: '1px solid #dee2e6', 
        borderRadius: '4px',
        marginBottom: '10px'
      }}>
        <Text size="sm" c="dimmed" style={{ fontStyle: 'italic' }}>
          💡 Gợi ý: Double-click vào hàng bất kỳ để xem thông tin chi tiết nhanh
        </Text>
      </div>
      <div className="mt-5">
        <MantineReactTable table={table} />
      </div>
      
      {/* Company Statistics Modal */}
      <CompanyStatisticsModal
        opened={companyStatsOpened}
        onClose={() => setCompanyStatsOpened(false)}
      />
    </>
  );
};
export default TaskTable;
